// Görselleri ücretsiz Cloudinary'ye yükler (unsigned upload, sunucu gerektirmez).
// Aşağıdaki iki değeri kendi Cloudinary hesabından doldur:
const CLOUDINARY_CLOUD_NAME = "dkvyd7yea";
const CLOUDINARY_UPLOAD_PRESET = "lingify_blog";

export const uploadImage = async (file) => {
  const data = new FormData();
  data.append("file", file);
  data.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);

  const res = await fetch(
    `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
    { method: "POST", body: data }
  );

  if (!res.ok) {
    throw new Error("Görsel yüklenemedi");
  }

  const json = await res.json();
  return json.secure_url;
};
